// Vendors
import React from 'react';
import { TxButton } from 'texkit-ui';

// Components
import Icon from '../Icon/Icon';
import { Trans } from '../Trans';

// Styles
import './language-selector.scss';

const LanguageSelector = ({ 
  locale, 
  isLanguageMenuOpen, 
  languageWrapperRef, 
  toggleLanguageMenu, 
  handleLanguageSelect 
}) => {
  return (
    <div className="language-selector-wrapper" ref={languageWrapperRef}>
      <TxButton
        type="button"
        className={`language-selector ${isLanguageMenuOpen ? 'language-selector--open' : ''}`}
        aria-label="Language selector"
        aria-haspopup="listbox"
        aria-expanded={isLanguageMenuOpen}
        onClick={toggleLanguageMenu}
      >
        <span className="language-selector__label">{locale === 'en' ? 'ENG' : 'ESP'}</span>
        <Icon
          name="chevronDown"
          className={`language-selector__icon ${isLanguageMenuOpen ? 'language-selector__icon--open' : ''}`}
        />
      </TxButton>

      {isLanguageMenuOpen && (
        <div className="language-selector__dropdown" role="listbox" aria-label="Language">
          <TxButton
            type="button"
            className={`language-selector__option ${locale === 'en' ? 'language-selector__option--selected' : ''}`}
            role="option"
            aria-selected={locale === 'en'}
            onClick={() => handleLanguageSelect('en')}
          >
            <span className="language-selector__option-text">
              <Trans file="auth" id="languageOptionEnglish" />
            </span>
            {locale === 'en' && (
              <Icon name="tick" className="language-selector__option-tick" />
            )}
          </TxButton>
          <TxButton
            type="button"
            className={`language-selector__option ${locale === 'es' ? 'language-selector__option--selected' : ''}`}
            role="option"
            aria-selected={locale === 'es'}
            onClick={() => handleLanguageSelect('es')}
          >
            <span className="language-selector__option-text">
              <Trans file="auth" id="languageOptionSpanish" />
            </span>
            {locale === 'es' && (
              <Icon name="tick" className="language-selector__option-tick" />
            )}
          </TxButton>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
